import { useSelector } from 'react-redux';
import { isDefined } from '../utils';

export default function useAssignmentsToAssign() {
  const assignmentsToAssign = useSelector(
    (state) =>
      (state.CourseAssignReducer.assignments.studentAssignments &&
        state.CourseAssignReducer.assignments.studentAssignments.filter(
          (assignment) =>
            assignment.isSelected &&
            (!isDefined(assignment.assignment) ||
              !isDefined(assignment.assignment.assignStatus))
        )) ||
      []
  );
  return assignmentsToAssign;
}



// WEBPACK FOOTER //
// ./helpers/hooks/use-assignment-to-assign.js